import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export const GroupSchema = BaseSchema.extend({
  slide: z.string().uuid(),
  annotations: z.array(z.string().uuid()).default([]),
  name: z.string().max(255),
  order: z.number(),
  color: z.string().max(255).nullable().default(null),
  description: z.string().nullable().default(null),
});

export type Group = z.infer<typeof GroupSchema>;

export const GroupEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: GroupSchema,
});

export type GroupEntityQueryResult = z.infer<typeof GroupEntityQueryResultSchema>;
